import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import AskTheAIPage from './AskTheAIPage';

const AskTheAIRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('AskTheAIRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={AskTheAIPage} />
            </Switch>
        </>
    );
};

export default AskTheAIRoutes;
